module.exports = __webpack_public_path__ + "static/media/work4.fd8ec0e9.jpg";